import React, { useState } from "react";
import * as sanitizeHtml from "sanitize-html";
import Link from "../global/Link";
import SectionNumber from "../global/SectionNumber";

const Job = (props, location) => {
  const { data, shareHandler } = props;

  function makeIdSafe(str) {
    if (!str) {
      return;
    }
    str = str.replace(/\s+/g, "-").toLowerCase();
    return str;
  }

  function deptColour(dept) {
    const depts = {
      animation: "pink",
      art: "pink",
      design: "blue",
      engineering: "red",
      "game-engineering": "red",
      operations: "green",
      production: "yellow",
      speculative: "green",
    };

    return depts[dept];
  }

  const colour =
    deptColour(makeIdSafe(data.department) || "unknown") || "white";

  return (
    <>
      <div
        className={`border border-${colour} rounded-2xl mb-5 md:mb-6 p-5 md:p-6 bg-black text-${colour} flex flex-row gap-3 relative`}
      >
        <div className="flex flex-col gap-2 w-full">
          <SectionNumber title={data?.shortcode ? data.shortcode : "---"} />
          <h5 className="text-white m-0">{data?.title && data?.title}</h5>

          <div
            className={`flex flex-col md:flex-row gap-1 md:gap-3 text-xs justify-start md:justify-end md:absolute md:top-4 md:right-6`}
          >
            {data?.department && (
              <span className="tracking-wide">{data.department}</span>
            )}
            {data?.employment_type && (
              <span className="tracking-wide">{data.employment_type}</span>
            )}
            {data?.city && <span className="tracking-wide">{data.city}</span>}
          </div>
        </div>

        <div className="flex flex-col justify-end md:flex-row gap-3 md:w-auto md:ms-auto md:mt-6 content-end">
          <Link
            to=""
            onClick={() => shareHandler(data)}
            button={true}
            icon="share"
            className={`text-${colour} border border-2 border-${colour}`}
          >
            Share
          </Link>
          <Link
            to={`/careers/${data?.shortcode}`}
            button={true}
            icon={true}
            className={`bg-${colour}  border border-2 border-${colour} text-black`}
            state={{ prevPath: location.pathname }}
          >
            More
          </Link>
        </div>
      </div>
    </>
  );
};

export default Job;
